import { FetchPolicy, useQuery } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';

import { CreditCardsDocument } from './creditCards.gql';

const useCreditCards = (options?: { fetchPolicy: FetchPolicy }) => {
  const { companyProfileId, companyUserId } = useCompanyContext();

  if (!companyProfileId) {
    throw new Error('companyProfileId is not defined in "useCreditCards"');
  }

  const { data, ...hook } = useQuery(CreditCardsDocument, {
    fetchPolicy: options?.fetchPolicy ?? 'cache-and-network',
    skip: !companyProfileId || !companyUserId,
    variables: { companyProfileId },
  });

  const companyCards =
    data?.viewer.company.creditCards.filter(
      ({ status }) => status !== 'DEACTIVATED',
    ) ?? [];

  const userCards =
    companyCards?.filter(
      (creditCard) => creditCard.companyUserId === companyUserId,
    ) ?? [];

  const refetchUserPaymentCardsQuery = async () => {
    if (companyProfileId && companyUserId) {
      await hook.refetch();
    }
  };

  return {
    companyCards,
    companyUserId,
    userCards,
    ...hook,
    refetch: refetchUserPaymentCardsQuery,
  };
};

export default useCreditCards;

export type CreditCards = NonNullable<
  ReturnType<typeof useCreditCards>['companyCards']
>;
export type CreditCard = CreditCards[number];
